import domain from "@/environment";
import axios from "axios";

const state = {
  ah: null,
  ahs: [],
  ahRows: 0,
  ahLoading: false,
  error: null,
};

const getters = {
  getAH: (state) => state.ah,
  getAllAH: (state) => state.ahs,
  getTotalRowAH: (state) => state.ahRows,
  getAHLoading: (state) => state.ahLoading,
  getAHError: (state) => state.error,
};

const mutations = {
  DO_NOTHING() {},
  SET_AH_LOADING(state, payload) {
    state.ahLoading = payload || false;
  },
  SET_AH(state, payload) {
    state.ah = payload ? payload : null;
  },
  SET_AHS(state, payload) {
    state.ahs = payload ? payload : [];
  },
  PUSH_AH(state, payload) {
    state.ahs.push(payload);
  },
  UPDATE_AH(state, payload) {
    for (let index = 0; index < state.ahs.length; index++) {
      if (state.ahs[index].id === payload.id) {
        state.ahs[index] = payload;
        break;
      }
    }
  },
  DELETE_AH(state, payload) {
    state.ahs = state.ahs.filter((item) => item.id !== payload.id);
  },
  UPDATE_AH_ROW(state, payload) {
    state.ahRows = payload ? payload : 0;
  },
  SET_AH_ERROR(state, payload) {
    state.error = payload ? payload : null;
  },
};

const actions = {
  async allAH({ commit }, payload) {
    commit("SET_AH_LOADING", true);
    const params = {
      page: payload?.page || 1,
      per_page: payload?.per_page || 10,
      search: payload?.search || null,
      start_date: payload?.start_date || null,
      end_date: payload?.end_date || null,
      entreprise: payload?.entreprise ? payload.entreprise.id : null,
      entreprise_id: payload?.entreprise_id || null,
      client_id: payload?.client_id || null,
      ocrdossier_id: payload?.ocrdossier_id || null,
    };
    try {
      const response = await axios.get(domain + "/ah", {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
        params,
      });

      // Gérer le cas où data est un tableau directement ou dans data.data
      const ahData = Array.isArray(response.data.data) 
        ? response.data.data 
        : response.data.data?.data || [];
      
      if (ahData.length > 0) {
        commit("UPDATE_AH_ROW", ahData.length);
        commit("SET_AHS", ahData);
      } else {
        commit("SET_AHS", []);
        commit("UPDATE_AH_ROW", 0);
      }
      commit("SET_AH_LOADING", false);
      return response.data;
    } catch (error) {
      commit("SET_AH_LOADING", false);
      commit(
        "SET_AH_ERROR",
        error?.response?.data?.message || error?.message || "Une erreur est survenue."
      );
      throw error?.response?.data?.message || error?.message || "Une erreur est survenue.";
    }
  },

  async getOneAH({ commit }, payload) {
    commit("SET_AH_LOADING", true);
    try {
      const response = await axios.get(domain + `/ah/` + payload, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("SET_AH", response.data.data);
      commit("SET_AH_LOADING", false);
      return response.data;
    } catch (error) {
      commit("SET_AH_LOADING", false);
      commit(
        "SET_AH_ERROR",
        error?.response?.data?.message || error?.message || "Une erreur est survenue."
      );
      throw error?.response?.data?.message || error?.message || "Une erreur est survenue.";
    }
  },

  async storeAH({ commit }, payload) {
    commit("SET_AH_LOADING", true);
    try {
      const response = await axios.post(domain + `/ah`, payload, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("PUSH_AH", response.data.data);
      commit("SET_AH_LOADING", false);
      return response.data;
    } catch (error) {
      commit("SET_AH_LOADING", false);
      commit(
        "SET_AH_ERROR",
        error?.response?.data?.message || error?.message || "Une erreur est survenue."
      );
      throw error?.response?.data?.message || error?.message || "Une erreur est survenue.";
    }
  },

  async updateAH({ commit }, payload) {
    commit("SET_AH_LOADING", true);
    try {
      const response = await axios.put(domain + `/ah/` + payload.id, payload, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("UPDATE_AH", response.data.data);
      commit("SET_AH_LOADING", false);
      return response.data;
    } catch (error) {
      commit("SET_AH_LOADING", false);
      commit(
        "SET_AH_ERROR",
        error?.response?.data?.message || error?.message || "Une erreur est survenue."
      );
      throw error?.response?.data?.message || error?.message || "Une erreur est survenue.";
    }
  },

  async deleteAH({ commit }, payload) {
    commit("SET_AH_LOADING", true);
    try {
      await axios.delete(domain + `/ah/` + payload.id, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("DELETE_AH", payload);
      commit("SET_AH_LOADING", false);
      return true;
    } catch (error) {
      commit("SET_AH_LOADING", false);
      commit(
        "SET_AH_ERROR",
        error?.response?.data?.message || error?.message || "Une erreur est survenue."
      );
      throw error?.response?.data?.message || error?.message || "Une erreur est survenue.";
    }
  },

  async generatePdfAH({ commit }, payload) {
    commit("SET_AH_LOADING", true);
    try {
      const response = await axios.get(domain + `/ah/` + payload + `/generate-pdf`, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("SET_AH_LOADING", false);
      return response.data;
    } catch (error) {
      commit("SET_AH_LOADING", false);
      commit(
        "SET_AH_ERROR",
        error?.response?.data?.message || error?.message || "Une erreur est survenue."
      );
      throw error?.response?.data?.message || error?.message || "Une erreur est survenue.";
    }
  },

  async downloadPdfAH({ commit }, payload) {
    commit("SET_AH_LOADING", true);
    try {
      const response = await axios.get(domain + `/ah/` + payload + `/download-pdf`, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("SET_AH_LOADING", false);
      return response.data;
    } catch (error) {
      commit("SET_AH_LOADING", false);
      commit(
        "SET_AH_ERROR",
        error?.response?.data?.message || error?.message || "Une erreur est survenue."
      );
      throw error?.response?.data?.message || error?.message || "Une erreur est survenue.";
    }
  },
};

export default { state, mutations, getters, actions };

